<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #empty>
            <div class="text-center empty-results">
              <div class="d-flex flex-column align-items-center text-center mb-1">
                <span class="mt-4">Non sono stati trovati risultati</span>
              </div>
            </div>
          </template>
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #cell(insurer_id)="row">
            {{ row.item.insurer_id ? retriveInsurerInfo(row.item) : "-" }}
          </template>
          <template #cell(type_description)="row">
            <span class="uc-first">{{
              manipulateTypeDescription(row.item)
            }}</span>
          </template>
          <template #cell(detail)="row">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Visualizza dettagli"
                @click="
                  customOpenDetailsModal(row.item, row.index, $event.target)
                "
              >
                <base-icon name="eye"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash"></base-icon>
              </b-button>
            </div>
          </template>

          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                  ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>

      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
          <span :data-active="active">{{
              page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }}</span>
              </template>
              <template v-slot:first-text>
          <span
          ><base-icon
            scale="-1"
            name="chevron_right_last_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:prev-text>
          <span
          ><base-icon
            scale="-1"
            name="chevron_right_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:next-text>
          <span
          ><base-icon
            name="chevron_right_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:last-text>
          <span
          ><base-icon
            name="chevron_right_last_rounded"
            width="16"
            height="16"
          /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
        totalItems && !noInputPaginator && totalPages && totalPages > 3
      "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>

      <b-modal
        :dialog-class="customModalClass"
        :id="infomodalName"
        :title="custoModalTitle"
        :size="custoModalSize"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14" />
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab> </button-group-tab>

              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/log/import-annulli-notturni/details/General";
import client from "@/repositories/api";

export default {
  name: "AnnulliNotturniTable",
  extends: template,
  data() {
    return {
      args: null,
      importers: [],
      selected: "General",
      modalResourceId: null,
      customModalClass: "modal-dettagli-importatori",
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      custoModalTitle: "Dettagli",
      custoModalSize: "md",
      modalTitleDefault: "Dettagli",
      modalSizeDefault: "md",
      tabIndex: 0,
      tabs: [{ name: "General", text: "Dettagli" }],
      dbRowData: null,
    };
  },
  components: {
    BaseIcon,
    ButtonGroupTab,
    General,
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    customOpenDetailsModal(item, index, target) {
      // this.tabIndex = 0; // TabIndex ID dei Dettagli
      // this.custoModalTitle = this.modalTitleGroup;
      // this.custoModalSize = this.modalSizeGroup;
      this.customModalClass += " custom-details-tab-open";
      this.openModal(item, index, target);
    },
    customized(item) {
      let c = {};
      c.descrizione = item.description;
      c.titolo = item.title;
      return c;
    },
    manipulateTypeDescription(item) {
      if (!item.type_description) return "-";
      let str = item.type_description.replace(/_/g, " ");
      return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    },
    retriveInsurerInfo(item) {
      if (!item.insurer_id) return "-";
      return this.importers.find(
        (importer) => importer.value == item.insurer_id
      ).text;
    },
  },
  beforeMount() {
    this.args = this.$parent.$parent.args;
  },
  created() {
    this.isLoading = true;
    const url = `insurers/create`;
    client
      .get(url)
      .then((response) => {
        const fields = response.data.fields;
        console.log("response", response);
        console.log("fields", fields);
        if (fields?.importer_id?.options)
          this.importers = fields?.importer_id?.options;
      })
      .catch((error) => {
        console.error(error);
      });
    // .finally(() => {
    //   this.isLoading = false;
    // });
  },
};
</script>
<style lang="css">
.uc-first::first-letter {
  display: inline-block;
  text-transform: capitalize;
}
</style>
